import React, { useEffect, useState } from "react";
import axios from "axios";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";
const containerStyle = {
  width: "100%",
  height: "100vh",
};

export default function App() {
  const [buses, setBuses] = useState([]);

  const [stops, setStops] = useState([]);

  const [map, setMap] = useState(null);
  const [initialBoundsSet, setInitialBoundsSet] = useState(false); // new flag
  const [initialBounds, setInitialBounds] = useState(null);

  const fetchLocation = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/bus`);

      const busArray = res.data
        .filter((bus) => bus.lat && bus.lng)
        .map((bus) => ({
          id: bus._id,
          lat: Number(bus.lat),
          lng: Number(bus.lng),
        }));
      console.log("KEY:", process.env.REACT_APP_GOOGLE_MAPS_API_KEY);
      console.log("BUS ARRAY:", busArray);

      setBuses(busArray);
    } catch (err) {
      console.log("fetching location err", err);
    }
  };
  const fetchStops = async () => {
    try {
      const res = await axios.get(`${process.env.REACT_APP_API_URL}/route`);
      console.log("routes get request respones:", res);

      let allStops = [];

      res.data.forEach((route) => {
        route.stops.forEach((stop) => {
          allStops.push({
            id: stop._id,
            lat: Number(stop.lat),
            lng: Number(stop.lng),
            name: stop.name,
          });
        });
      });
      console.log("all stops array", allStops);
      setStops(allStops);
    } catch (err) {
      console.log("erron in route fetch", err);
    }
  };

  const resetMap = () => {
    if (map && initialBounds) {
      map.fitBounds(initialBounds);
    }
  };

  //fetch location every 5sec and unmount when component stop fetching location.
  useEffect(() => {
    fetchLocation();
    fetchStops();

    const interval = setInterval(fetchLocation, 5000); // every 5 sec
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    if (!map || !window.google || initialBoundsSet) return;

    const bounds = new window.google.maps.LatLngBounds();

    // add all stops to bounds
    stops.forEach((stop) => {
      if (typeof stop.lat === "number" && typeof stop.lng === "number") {
        bounds.extend({ lat: stop.lat, lng: stop.lng });
      }
    });

    // add  buses to bounds
    buses.forEach((bus) => {
      if (typeof bus.lat === "number" && typeof bus.lng === "number") {
        bounds.extend({ lat: bus.lat, lng: bus.lng });
      }
    });

    if (!bounds.isEmpty()) {
      map.fitBounds(bounds);
      setInitialBounds(bounds);
      setInitialBoundsSet(true); // ✅ only do this once
    }
  }, [map, stops, buses, initialBoundsSet]);

  return (
    <LoadScript
      googleMapsApiKey={process.env.REACT_APP_GOOGLE_MAPS_API_KEY}
      loadingElement={
        <div
          style={{
            height: "100vh",
            width: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <p>Loading Map...</p>
        </div>
      }
    >
      <button
        onClick={resetMap}
        style={{
          position: "absolute",
          top: "10px",
          left: "10px",
          zIndex: 1,
          padding: "8px 12px",
          background: "#fff",
          border: "1px solid #ccc",
          cursor: "pointer",
          marginTop: 80,
        }}
      >
        Reset Map
      </button>
      <GoogleMap
        mapContainerStyle={containerStyle}
        onLoad={(mapInstance) => setMap(mapInstance)}
      >
        {stops.map((stop) =>
          typeof stop.lat === "number" && typeof stop.lng === "number" ? (
            <Marker
              key={`stop-${stop.id}`}
              position={{ lat: stop.lat, lng: stop.lng }}
              icon={{
                url: "https://maps.google.com/mapfiles/ms/icons/red-dot.png",
              }}
            />
          ) : null,
        )}

        {buses.map((bus) =>
          typeof bus.lat === "number" && typeof bus.lng === "number" ? (
            <Marker
              key={bus.id}
              position={{ lat: bus.lat, lng: bus.lng }}
              icon={{
                url: "https://maps.google.com/mapfiles/kml/shapes/bus.png",
              }}
            />
          ) : null,
        )}
      </GoogleMap>
    </LoadScript>
  );
}
